export {
  ACCUMS_TEXTS,
  FUB_COMMON_STATUS,
  TITLE_TETHERING,
  UNLIM_MODAL,
  UnlimThreeStatus,
} from './accumulators';
export { CORPORATE_BALANCE_TEXT, defaultNextBillingDateText } from './billing';
export { BASKET_COOKIE_NAME, BASKET_URL } from './cart';
export { dictionary } from './dictionary';
export { TARIFF_TEXTS } from './tariff';

export const USER_TYPE = {
  FTTB: 'fttb',
  CONVERGENT: 'convergent',
  MOBILE: 'mobile',
} as const;

export const SUBSCRIPTION_TYPES = {
  partnerSubscriptions: 'partner-subscriptions',
  subscriptions: 'subscriptions',
  services: 'services',
} as const;

export const NOTIFICATION_TIMEOUT = 1000;

export const ERROR_TEXTS = {
  error: {
    title: 'Что-то пошло не по плану',
    text: 'Обновите страницу или приходите позднее',
  },
  somethingWrong: {
    title: 'Что-то пошло не так. Часть услуг не загрузилась',
    text: '',
  },
};

/** Типы страниц, для аналитики */

export enum SETTINGS_PAGE_TYPE {
  'Основные' = 'number_settings',
  'Безопасность' = 'security_settings',
  'Подтверждение персональных данных' = 'personal-data_settings',
}

export const BALANCE_TYPES = {
  Personal: 'Personal',
  CAC: 'CAC',
  Additional: 'Additional',
  UB: 'UB',
} as const;

export const REFILLABLE_TYPES: Record<string, string> = {
  Personal: BALANCE_TYPES.Personal,
  CAC: BALANCE_TYPES.CAC,
  UB: BALANCE_TYPES.UB,
};

export const STORE_ICONS_LINK = [
  'https://static.beeline.ru/upload/images/b2c/icons/22988_AppStoreDark.svg',
  'https://static.beeline.ru/upload/images/b2c/icons/22988_GoogleStore.svg',
  'https://static.beeline.ru/upload/images/b2c/icons/22988_HuaweiStore.svg',
  'https://static.beeline.ru/upload/images/b2c/icons/22988_RuStore.svg',
];

export const DEFAULT_COMBO_INFO = {
  button: {
    title: '',
    logos: [],
    action: '',
    url: '',
  },
  modal: {
    modalTitle: '',
    subtitle: '',
    qrCode: '',
    text: '',
    image: '',
  },
};
export const enum MobileUserEnum {
  Mobile = 'mobile',
  Business = 'business',
}
